var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"d-flex flex-column justify-center align-center"},[_c('v-img',{attrs:{"src":_vm.IMAGE_URL,"width":"9rem"}}),_c('h1',{staticClass:"text-h6 overline font-weight-bold text-center"},[_vm._v("Edunix manager")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }